import script from "./PlanProject.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanProject.vue?vue&type=script&setup=true&lang=js"

import "./PlanProject.vue?vue&type=style&index=0&id=65ae8feb&scoped=true&lang=scss"

import exportComponent from "F:\\hwx\\proj\\vscode\\twzc_system_web\\dataV\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ae8feb"]])

export default __exports__